import React, { useState } from "react";

type SelectableOptionEditorProps = {
    options: string[];
    onChange: (opts: string[]) => void;
    disabled?: boolean; // ✅ add this
};

const SelectableOptionEditor: React.FC<SelectableOptionEditorProps> =
    ({
       options,
       onChange,
       disabled = false,
   }) => {
    const [input, setInput] = useState("");
    // "" = at the end; otherwise the 0-based index to insert BEFORE.
    const [insertAt, setInsertAt] = useState("");

        const addOption = () => {
            if (disabled) return;

            const trimmed = input.trim();
            if (trimmed && !options.includes(trimmed)) {
                const idx = insertAt === "" ? options.length : Number(insertAt);
                const next = [...options];
                next.splice(Math.min(idx, options.length), 0, trimmed);
                onChange(next);
                setInput("");
                setInsertAt("");
            }
        };

        const removeOption = (opt: string) => {
            if (disabled) return;
            onChange(options.filter((o) => o !== opt));
        };

        return (
            <div className="selectable-editor" style={{ opacity: disabled ? 0.6 : 1 }}>
                <div className="selectable-editor-input-row">
                    <input
                        type="text"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Add new option"
                        disabled={disabled}
                    />
                    {options.length > 0 && (
                        <select
                            value={insertAt}
                            onChange={(e) => setInsertAt(e.target.value)}
                            disabled={disabled}
                            title="Where to insert the new option"
                            style={{ width: "auto" }}
                        >
                            <option value="">At the end</option>
                            {options.map((opt, i) => (
                                <option key={opt} value={i}>Before “{opt}”</option>
                            ))}
                        </select>
                    )}
                    <button
                        type="button"
                        onClick={addOption}
                        disabled={disabled || !input.trim()}
                        className="btn-sm selectable-editor-add-btn"
                    >
                        Add
                    </button>
                </div>

                <ul className="selectable-editor-list">
                    {options.map((opt) => (
                        <li key={opt} className="selectable-editor-item">
                            <span className="selectable-editor-item-label">{opt}</span>
                            <button
                                type="button"
                                onClick={() => removeOption(opt)}
                                disabled={disabled}
                                className="btn-sm selectable-editor-remove-btn"
                            >
                                Remove
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        );
};

export default SelectableOptionEditor;